import PageMetaData from "../../../components/PageMetaData";
import TopNavBar from "../../../components/TopNavBar";
import { HelmetProvider } from "react-helmet-async";
import { LayoutProvider } from "../../../context/useLayoutContext";
import { useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { CommonServiceContext } from "../../../services/common/commonService";
import Loader from "../../../components/Loader";
import TextWithBreaks from "../../../components/common/TextWithBreaks";
import Footer from "../components/Footer";
import Calculator from "../components/Calculator";

const Service = () => {
  const { id } = useParams();
  const { loading, getService, service } = useContext(CommonServiceContext);
  const [bgImageUrl, setBgImageUrl] = useState("");

  const [showCalculator, setShowCalculator] = useState(false);

  const handleShowCalculator = () => {
    console.log("Calculator button clicked");
    setShowCalculator(!showCalculator);
  };

  const getServiceById = async (id) => {
    var response = await getService(id);
  };

  useEffect(() => {
    if (id) {
      getServiceById(id);
    }
  }, [id]);

  useEffect(() => {
    if (service && service.bgImageUrl) {
      //console.log(service.bgImageUrl);
      const charactersArray = service.bgImageUrl.split("");
      const joinedCharacters = charactersArray.join("");
      //console.log(joinedCharacters);
      setBgImageUrl(joinedCharacters);
    }
  }, [service]);

  return (
    <>
      {loading && <Loader />}
      <HelmetProvider>
        <LayoutProvider>
          <PageMetaData
            title={service ? service.name : "GEO Express | Services"}
          />
          <TopNavBar
            position="fixed"
            menuItems={[
              ["მთავარი", "home", "/"],
              ["სერვისები", "services", "/services", true],
              ["სიახლეები", "news", "/news"],
              ["კონტაქტი", "contact", "/contact"],
              ["ხშირად დასმული კითხვები", "faqs", "/faq"],
              ["განსაბაჟებელი გზავნილები", "shipment", "/shipment"],
            ]}
            onCalculatorClick={handleShowCalculator}
          />

          <Calculator
            show={showCalculator}
            onClose={() => handleShowCalculator(false)}
          />
          <div className="container">
            <section className="flex items-start justify-between h-auto mt-24">
              {/* <div
              className="w-2/5 h-full bg-cover bg-center"
              style={{ backgroundImage: `url(${bgImageUrl})` }}
            ></div> */}
              <img
                className="w-4/12 h-full bg-cover bg-center"
                alt="img"
                src={bgImageUrl}
              ></img>

              <div className="w-7/12 bg-white p-6 shadow-lg rounded-lg">
                <h2 className="text-2xl font-semibold text-gray-800">
                  {service?.name}
                </h2>
                <h4 className="mt-4 text-gray-600">
                  <TextWithBreaks text={service?.text} />
                </h4>
              </div>
            </section>
          </div>
          <Footer />
        </LayoutProvider>
      </HelmetProvider>
    </>
  );
};

export default Service;
